import { useState } from "react";
import { ChevronRight, LayoutDashboard, Wrench } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import Rodape from "../rodape/Rodape";
import FormularioTipoServico from "./FormularioTipoServico";
import TabelaTiposServico from "./TabelaTiposServico"; // 🔗 importa tabela

export default function TiposServico() {
  const [modoFormulario, setModoFormulario] = useState(false);
  const [tipoEdicao, setTipoEdicao] = useState(null); // 🔹 guarda item que vai editar

  const handleNovoTipoServico = () => {
    setTipoEdicao(null); // novo registro → sem dados
    setModoFormulario(true);
  };

  const handleEditar = (item) => {
    setTipoEdicao(item); // seta item para edição
    setModoFormulario(true);
  };

  return (
    <div className="h-full w-full relative overflow-hidden flex flex-col">
      <AnimatePresence mode="wait">
        {!modoFormulario ? (
          // ===== Tela Principal =====
          <motion.div
            key="principal"
            initial={{ x: 0, opacity: 1 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "-100%", opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="flex-1 w-full h-full p-6 pt-4 flex flex-col"
          >
            {/* 🔗 Breadcrumb */}
            <nav
              className="flex items-center space-x-3 text-sm mb-4"
              aria-label="Breadcrumb"
            >
              <LayoutDashboard size={16} className="text-slate-600" />
              <span className="cursor-pointer font-medium text-slate-700 hover:underline">
                Painel de Chamados
              </span>
              <ChevronRight size={12} className="text-slate-500" />
              <span className="cursor-pointer font-medium text-slate-700 hover:underline">
                Cadastros
              </span>
              <ChevronRight size={12} className="text-slate-500" />
              <span className="text-slate-700 font-medium">
                Tipos de Serviços
              </span>
            </nav>

            {/* 📦 Quadro principal */}
            <section className="bg-white rounded-md shadow-sm border border-[#4d4d4d] overflow-hidden flex-1 flex flex-col">
              {/* Barra superior */}
              <div className="w-full bg-[#2b2b2b] px-4 py-2 flex items-center">
                <button
                  onClick={handleNovoTipoServico}
                  aria-label="Abrir novo tipo de serviço"
                  className="flex items-center gap-2 px-4 py-2 text-white font-medium rounded 
                             transition-transform duration-200 hover:scale-105 bg-[#f95000]"
                >
                  <Wrench size={18} />
                  <span className="hidden sm:inline">Novo Tipo de Serviço</span>
                </button>
              </div>

              {/* Tabela com espaçamento interno */}
              <div className="flex-1 p-6">
                <TabelaTiposServico onEditar={handleEditar} />
              </div>
            </section>

            <div className="mt-4">
              <Rodape />
            </div>
          </motion.div>
        ) : (
          // ===== Tela Formulário =====
          <motion.div
            key="formulario"
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100%", opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="w-full h-full p-6 flex flex-col"
          >
            <FormularioTipoServico
              dadosEdicao={tipoEdicao} // 🔗 passa dados se for edição
              onVoltar={() => setModoFormulario(false)}
              onSalvo={() => setModoFormulario(false)}
            />

            <div className="mt-4">
              <Rodape />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
